import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { reqData } from "../../../js/server";
import SubMenu from "../../comm/SubMenu";
import List from "../../comm/List";
import Paging from "../../comm/Paging";
import SubBanner from "../../comm/SubBanner";
import ImageMap from "image-map";
import queryString from "query-string";

function UnionMem({ match, location, history }) {
  const dispatch = useDispatch();
  const [posts, setPosts] = useState([]);
  const [areaItem, setAreaItem] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const query = queryString.parse(location.search);
  const testkind = query.testkind || "";

  async function fetchData(page = 1) {
    //Hash에 남길 State 저장
    setCurrentPage(Number(page));
    const keyword = document.querySelector("#inputKeyword").value;
    const area = document.querySelector("#inputArea").value;

    const jsonData = {
      servicename: "OpenShopList",
      area,
      keyword,
      testkind,
      currentPage: page,
      maxListCount: postsPerPage,
    };

    reqData(jsonData)
      .then((res) => {
        if (res.data.result === "OK") {
          setTotalCount(res.data.totalCnt);
          setPosts(res.data.jsonData);
          setAreaItem(res.data.jsonArea);
        } else {
          console.error(res.data.msg);
          setTotalCount(0);
          setPosts([]);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({ type: "loadingChange", payload: false });
      });
  }

  const fnSearchClick = () => {
    const keyword = document.querySelector("#inputKeyword").value;

    if (keyword.length > 1) {
      fetchData(1);
    } else {
      alert("검색어는 2자 이상 필요합니다.");
    }
  };

  const setPage = (page) => {
    fetchData(page);
  };

  const selectedArea = (area) => {
    document.querySelector("#inputArea").value = area;
    fetchData(1);
  };

  const fetchSubTitle = () => {
    switch (testkind) {
      case "1":
        return (
          <div className="col-12">
            <h2>종합검사 업체안내</h2>
            강원특별자치도의 종합검사 전문 업체를 한눈에 확인하세요.
          </div>
        );
      case "2":
        return (
          <div className="col-12">
            <h2>정기검사 업체안내</h2>
            안전과 신뢰를 기반으로 한 강원특별자치도의 정기검사 업체 정보를
            제공합니다.
          </div>
        );
      default:
        return (
          <div className="col-12">
            <h2>정비업체현황</h2>
            강원특별자치도 자동차종합정비업을 이끌어 가는 정비업체 현황입니다.
          </div>
        );
    }
  };

  useEffect(
    () => {
      dispatch({ type: "loadingChange", payload: true });

      setTimeout(() => {
        ImageMap("img[usemap]");

        let payload = "";
        switch (testkind) {
          case "1":
            payload = { sub01: "정비업체현황", sub02: "종합검사 업체안내" };
            break;
          case "2":
            payload = { sub01: "정비업체현황", sub02: "정기검사 업체안내" };
            break;
          default:
            payload = { sub01: "정비업체현황", sub02: "정비업체현황" };
            break;
        }
        dispatch({
          type: "pageChange",
          payload: payload,
        });

        fetchData(1);
      }, 500);
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <SubBanner id="union_mem" />

      <section className="adminboard section">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div className="row">{fetchSubTitle()}</div>

              <div className="row search-bar">
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <div className="input-group mb-3 mt-3">
                    <select
                      id="inputArea"
                      className="custom-select"
                      name="inputArea"
                      onChange={(e) => fetchData(1)}
                    >
                      <option value="">지역선택</option>
                      {areaItem.map((item, idx) => (
                        <option value={item.area} key={idx}>
                          {item.area}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-8 col-md-8 col-sm-12">
                  <div className="input-group mb-3 mt-3">
                    <input
                      type="text"
                      id="inputKeyword"
                      className="form-control"
                      placeholder="업체명, 대표자명, 주소"
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          fnSearchClick();
                        }
                      }}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-custom-search"
                        type="button"
                        onClick={() => {
                          fnSearchClick();
                        }}
                      >
                        <i className="icofont-search-2" />
                      </button>
                      <button
                        className="btn btn-custom-init"
                        type="button"
                        onClick={() => {
                          document.getElementById("inputKeyword").value = "";
                          fetchData(1);
                        }}
                      >
                        <i className="icofont-eraser" />
                      </button>
                    </div>
                  </div>
                </div>

                {!testkind ? (
                  <div className="row map-pc-div">
                    <div className="col-12 col-md-2">&nbsp;</div>
                    <div className="col-12 col-md-8">
                      <img
                        src="/images/gw_map_sub.png"
                        alt="지역선택"
                        style={{ width: "100%" }}
                        usemap="#image-map"
                      />
                    </div>
                    <div className="col-12 col-md-2">&nbsp;</div>
                  </div>
                ) : null}
              </div>

              <div className="row">
                <div className="table-responsive datatable-list">
                  <List posts={posts} id="UnionMem" />
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <Paging
                    page={currentPage}
                    count={totalCount}
                    setPage={setPage}
                  />
                </div>
              </div>
            </div>

            <SubMenu id="unionMem" />
          </div>
        </div>
      </section>

      <map name="image-map" id="image-map">
        <area
          target="_self"
          alt="철원"
          title="철원"
          onClick={(e) => selectedArea("철원")}
          coords="34,115,112,173"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="화천"
          title="화천"
          onClick={(e) => selectedArea("화천")}
          coords="142,127,209,203"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="양구"
          title="양구"
          onClick={(e) => selectedArea("양구")}
          coords="227,135,286,196"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="인제"
          title="인제"
          onClick={(e) => selectedArea("인제")}
          coords="296,169,381,250"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="고성"
          title="고성"
          onClick={(e) => selectedArea("고성")}
          coords="343,60,408,127"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="속초"
          title="속초"
          onClick={(e) => selectedArea("속초")}
          coords="435,116,545,171"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="춘천"
          title="춘천"
          onClick={(e) => selectedArea("춘천")}
          coords="151,244,238,290"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="양양"
          title="양양"
          onClick={(e) => selectedArea("양양")}
          coords="407,200,475,246"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="홍천"
          title="홍천"
          onClick={(e) => selectedArea("홍천")}
          coords="227,295,342,356"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="횡성"
          title="횡성"
          onClick={(e) => selectedArea("횡성")}
          coords="253,372,329,436"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="평창"
          title="평창"
          onClick={(e) => selectedArea("평창")}
          coords="353,353,445,409"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="강릉"
          title="강릉"
          onClick={(e) => selectedArea("강릉")}
          coords="481,303,552,359"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="원주"
          title="원주"
          onClick={(e) => selectedArea("원주")}
          coords="201,453,285,525"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="영월"
          title="영월"
          onClick={(e) => selectedArea("영월")}
          coords="360,499,448,574"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="정선"
          title="정선"
          onClick={(e) => selectedArea("정선")}
          coords="440,438,510,495"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="동해"
          title="동해"
          onClick={(e) => selectedArea("동해")}
          coords="588,370,670,427"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="삼척"
          title="삼척"
          onClick={(e) => selectedArea("삼척")}
          coords="563,466,653,527"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
        <area
          target="_self"
          alt="태백"
          title="태백"
          onClick={(e) => selectedArea("태백")}
          coords="510,557,604,614"
          shape="rect"
          style={{ cursor: "pointer" }}
        />
      </map>
    </>
  );
}

export default UnionMem;
